import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { userById } from "../actions/userById";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
import { getDisplayName } from "../utils/displayName";
const TitleCompany = ({ title }) => {
  const [poster, setPoster] = useState(null);
  useEffect(() => {
    if (title?.title_company_used) {
      userById(title?.title_company_used, { setPoster });
    }
  }, [title]);
  return (
    <>
      {title && title["title_company_used"] && poster && (
        <>
          <h1 className="font-bold pt-8">Selected Title Company</h1>
          <Link
            to={`/user/${title["title_company_used"]}`}
            className="border-2 rounded-10 py-2 px-8 flex flex-col items-center justify-between hover:scale-105 hover:cursor-pointer transition-all w-[250px]"
          >
            <img
              className="h-[50px] w-[50px] object-cover rounded-full"
              src={
                poster?.picture_url
                  ? cloudinaryUrl(poster?.picture_url)
                  : "/error.png"
              }
              alt="title company"
            />
            <div className="w-full text-center">
              <h1 className="text-19">{getDisplayName(poster)}</h1>
              <p className="text-blue-500">{poster?.brokerage_name}</p>
              <p className="text-sm font-medium text-slate-700">
                {poster?.class_type}
              </p>
              {poster?.email_address && (
                <p className="text-xs text-slate-600 mt-1">
                  <a
                    href={`mailto:${poster.email_address}`}
                    className="hover:underline"
                  >
                    {poster.email_address}
                  </a>
                </p>
              )}
              {poster?.phone_number && (
                <p className="text-xs text-slate-600">
                  <a
                    href={`tel:${poster.phone_number}`}
                    className="hover:underline"
                  >
                    {poster.phone_number}
                  </a>
                </p>
              )}
            </div>
          </Link>
        </>
      )}
      {/* Fallback: Show free-text title company if set and no linked title company */}
      {title && !title["title_company_used"] && title["title_company_text"] && (
        <div className="mt-6 p-4 border rounded-10 bg-white shadow w-[300px]">
          <h2 className="font-bold mb-2">Preferred Title Company / Closer</h2>
          <p className="text-sm text-gray-700">{title["title_company_text"]}</p>
        </div>
      )}
    </>
  );
};

export default TitleCompany;
